import * as React from 'react';
import * as _ from 'lodash';

import styled from '@emotion/styled';

export interface ColumnLayout {
  key: string;
  elements: (JSX.Element | null)[];
}

export interface ColumnsLayoutWidgetProps {
  columns: ColumnLayout[];
}

export const ColumnsLayoutWidget: React.FC<ColumnsLayoutWidgetProps> = (props) => {
  return (
    <S.Container>
      {_.map(props.columns, (col, idx) => {
        return (
          <React.Fragment key={`${col.key}-${idx}`}>
            <S.Column key={`${col.key}-col-${idx}`}>
              {_.map(col.elements, (element, index) => {
                if (element === _.last(col.elements)) {
                  return element;
                }
                return <S.Pad key={`pad-${index}`}>{element}</S.Pad>;
              })}
            </S.Column>
            {col === _.last(props.columns) ? null : <S.Spacer />}
          </React.Fragment>
        );
      })}
    </S.Container>
  );
};

const BASE_LABEL = 'columns-layout-widet';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    display: flex;
    flex-direction: row;
  `;

  export const Column = styled.div`
    label: ${BASE_LABEL}__column;
    flex-grow: 1;
    width: 100%;
  `;

  export const Spacer = styled.div`
    label: ${BASE_LABEL}__spacer;
    width: 16px;
  `;

  export const Pad = styled.div`
    label: ${BASE_LABEL}__pad;
    margin-bottom: 16px;
  `;
}
